/**
 * @author xyguo
 * @description 角色管理==》人员维护管理页面,展示该角色下所有人员信息
 * @Date 2020/1/2
 */
import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './columns'

import { framework_tool ,component_tool,utils_tool} from '@/tool'
let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizCard} = component_tool;
let {Session} = utils_tool;

class RoleGroupList extends WizContainer {

  componentName = 'RoleGroupList';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let record = this.props.record;
    let roleName = '';
    let roleId = '';
    if (record) {
      Session.set('roleRecord',record);
    }
    if (Session.get('roleRecord')){
      let roleRecord = Session.get('roleRecord');
      roleName = roleRecord.name;
      roleId = roleRecord.id;
    }
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig:templateConfig({roleId}),
      roleId,
      apiDataFormat: {
        add: this._handleCMD,
        update: this._handleCMD,
        delete: this._handleCMD,
        enable: this._handleCMD
      },
    })
    let title = '当前角色名称:'+roleName;
     
      
    return <WizReduxTemplate {..._reduxTemplateCofig} />
    
    

     
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(RoleGroupList);
